<div class="screen-overlay">
  <nz-spin nzSimple nzSize="large"></nz-spin>
  <h3 *ngIf="params?.message" [innerHtml]="params?.message | safe: 'html'"></h3>
</div>
